<script setup lang="ts">
import { NxtModal } from '@future-harry/nxt-styles';

const props = defineProps<{
   title: string;
   message: string;
   confirmText?: string;
   cancelText?: string;
   isLoading?: boolean;
}>();

const emit = defineEmits<{
   (e: 'onConfirm'): void;
   (e: 'onCancel'): void;
}>();

const { t } = useI18n();

const confirmButtonText = computed(() => props.confirmText ?? t('actions.confirm'));
const cancelButtonText = computed(() => props.cancelText ?? t('actions.cancel'));

const handleConfirm = () => {
   if (!props.isLoading) {
      emit('onConfirm');
   }
};

const handleCancel = () => {
   if (!props.isLoading) {
      emit('onCancel');
   }
};
</script>

<template>
   <NxtModal
      :title="title"
      :primary-action-text="confirmButtonText"
      :cancel-text="cancelButtonText"
      :primary-action-disabled="isLoading"
      :has-cancel-button="!isLoading"
      @on-primary-action="handleConfirm"
      @on-cancel="handleCancel"
   >
      <div :class="['confirmation-modal']">
         <p class="confirmation-modal__message">{{ message }}</p>
      </div>
   </NxtModal>
</template>

<style scoped lang="scss">
.confirmation-modal {
   padding: var(--nxt-gutter);
   text-align: center;

   &__message {
      font-size: var(--nxt-font-medium);
      line-height: 1.5;
      color: var(--nxt-dark);
   }
}
</style>
